import { Component } from '@angular/core'
import { LoginService } from "src/app/public/service/login.service"
import { AuthService } from "./shared/services/auth.service"
import { NgxPermissionsService } from "ngx-permissions"
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Agricultura';
  param = { name: 'Cristian Cardenas' };
  constructor(
    private _loginService: LoginService,
    private _authService: AuthService,
    private _ngxPermissionsService: NgxPermissionsService
  ) {
    this.title = 'Agricultura'
  }
  async ngOnInit() {
    if (this._authService.isAuthenticated()) {
      await this._loginService.permiss(this._authService.getLogin()).then(async (res: any) => {
        const permissions = []
        for (let element of res.permissions) {
          permissions.push(element.slug)
        }
        await this._ngxPermissionsService.loadPermissions(permissions)
      })
        .catch((err) => { })
    }
  }
}
